import { useCallback } from 'react';
import { atom, useAtom } from 'jotai';
import { SetsByDelivery } from 'api/models/Sets';
import { ImplantsByDelivery } from 'api/models/Implants';

// this extra checkout flow data enabling checkout entire surgery flow would be
//  best in the checkOutTraysBySetAtom however at the time of making this there
//  were 185 touchpoints to update so the risk of regressing something was too high

export type CheckOutFlowType = 'SURGERY' | 'DELIVERY';

export type CheckOutFlowParams = {
  flowType: CheckOutFlowType;
  orderRecordId: string;
  deliveryId: string;
  setsByDelivery: SetsByDelivery;
  implantsByDelivery: ImplantsByDelivery;
  flowExited?: boolean;
  hasImplantsAwaitingNotification?: boolean;
  // Rep who took the equipment, captured during quick check out for the SalesRep reason
  returnedByRepId?: string;
};

const DEFAULT_CHECKOUT_FLOW_PARAMS: CheckOutFlowParams = {
  flowType: 'DELIVERY',
  orderRecordId: '',
  deliveryId: '',
  setsByDelivery: {},
  implantsByDelivery: {},
  flowExited: false,
  hasImplantsAwaitingNotification: false,
};

const checkOutFlowParamsAtom = atom<CheckOutFlowParams>(DEFAULT_CHECKOUT_FLOW_PARAMS);

export const useCheckOutFlowParams = () => {
  const [checkOutFlowParams, setCheckOutFlowParams] = useAtom(checkOutFlowParamsAtom);

  const setCheckOutFlowParam = useCallback(
    <K extends keyof CheckOutFlowParams>(key: K, val: CheckOutFlowParams[K]) => {
      setCheckOutFlowParams(prev => ({
        ...prev,
        [key]: val,
      }));
    },
    [setCheckOutFlowParams],
  );

  const resetCheckOutFlowParams = useCallback(() => {
    setCheckOutFlowParams(DEFAULT_CHECKOUT_FLOW_PARAMS);
  }, [setCheckOutFlowParams]);

  return { checkOutFlowParams, setCheckOutFlowParams, setCheckOutFlowParam, resetCheckOutFlowParams };
};
